import styled from 'styled-components';

export const RedSspan = styled.span`
	color: red;
`;
